import React, { useState } from 'react';
import { Field, Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ComboBox, Button, Toggler, TextInput } from '@components';
import { PPMSchema, PPMInitialValues, PPMDocs } from '@schemas';
import { enviaFormRequest } from '@store/user/actions';
import { ModalUpload } from './components/ModalUpload';
import { validaUpload } from './utils/validaUpload';
import { DadosUsuario } from './components/DadosUsuario';

const Anexos = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <ModalUpload modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      {PPMDocs.commons.map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                return (
                  <TextInput
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    label={anexo.label}
                    accept="image/*,.pdf"
                    multiple
                    onChange={(e) => {
                      return validaUpload({
                        anexo,
                        e,
                        form,
                        setModalIsOpen,
                      });
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}
    </>
  );
};

export const PPM = ({ title, reference }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showForm, setShowForm] = useState(false);

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>

        {showForm ? (
          <>
            <p className="mb-4">
              Venho, por meio deste, requerer à Fundação Forluminas de
              Seguridade Social - Forluz o pagamento do saldo de conta de
              aposentadoria do ex-participante abaixo discriminado, nos termos
              do Regulamento do Plano Taesa de Benefícios Previdenciários (Plano
              Taesaprev) e das normas vigentes e aquelas que venham a alterá-las
              ou substituí-las. Para tanto, anexo a documentação necessária para
              a finalidade.
            </p>
            <Formik
              validateOnMount
              initialValues={PPMInitialValues}
              validationSchema={PPMSchema()}
              onSubmit={(values) => {
                dispatch(
                  enviaFormRequest({
                    campos: values,
                    formulario: reference,
                    navigate,
                  })
                );
              }}
            >
              {({ handleSubmit, isValid }) => (
                <Form>
                  <div className="row">
                    <div className="col-md-12 col-lg-6">
                      <Field
                        className="mb-3"
                        name="acessoContraCheque"
                        label="Acesso ao contracheque via"
                        component={ComboBox}
                        options={['Portal', 'E-mail e portal'].map((x) => {
                          return { value: x, label: x };
                        })}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <p className="mb-3">
                      Com base na Lei nº 13.709/2018 (Lei Geral de Proteção de
                      Dados Pessoais), autorizo o tratamento dos meus dados
                      pessoais e dados pessoais sensíveis para fins relacionados
                      ao meu vínculo com a FORLUZ.
                    </p>
                    <div className="col-md-12 col-lg-6">
                      <Field
                        className="mb-3"
                        name="consentimentoDadosSensiveis"
                        component={Toggler}
                        label="Consentimento dados sensíveis (obrigatório)"
                      />
                      <Field
                        className="mb-3 mt-3"
                        name="aceiteInss"
                        component={Toggler}
                        createTermsField
                        label="Estou ciente que pessoa aposentada pela Previdência Oficial (INSS) e acometida por moléstia grave faz jus à isenção de Imposto de Renda. Este pedido poderá ser solicitado à Forluz a qualquer tempo através do formulário Isenção de Imposto de Renda disponível no menu Requerimentos. Se deferida, a isenção será processada no mês seguinte ao requerimento. "
                      />
                    </div>
                  </div>

                  <Anexos />

                  <Field
                    className="mb-3"
                    name="declaracaoVeracidade"
                    component={Toggler}
                    createTermsField
                    label="Declaro que as informações e os documentos por mim apresentados à Forluz são verdadeiros, estando ciente de que, caso não sejam autênticos, estarei sujeito às consequências civis e criminais cabíveis, além de autorizar a Forluz a anular o ato praticado ou o benefício concedido."
                  />

                  <hr className="mt-32 mt-xs-0 mb-32" />

                  <div className="row">
                    <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                      <div className="d-block d-md-flex align-items-center">
                        <Button
                          disabled={!isValid}
                          className="ms-0 ms-md-3"
                          onClick={handleSubmit}
                        >
                          Continuar
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <DadosUsuario
            onClick={() => {
              window.scroll(0, 0);
              setShowForm(true);
            }}
            dadosBancarios
          />
        )}
      </div>
    </div>
  );
};
